import * as React from 'react'
import { differenceInSeconds } from 'date-fns'
import { useTheme } from 'next-themes'
import { ImageWithSkeleton } from '@/components/ui/image-with-skeleton'

export function WaitTime({ since }: { since: string }) {
  const [seconds, setSeconds] = React.useState(() =>
    differenceInSeconds(new Date(), new Date(since))
  )

  React.useEffect(() => {
    const id = setInterval(() => {
      setSeconds(differenceInSeconds(new Date(), new Date(since)))
    }, 1000)
    return () => clearInterval(id)
  }, [since])

  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  const isLong = mins >= 10
  const isMedium = mins >= 5

  return (
    <span
      className={`text-xs font-mono tabular-nums ${
        isLong
          ? 'text-red-500 dark:text-red-400'
          : isMedium
            ? 'text-amber-500 dark:text-amber-400'
            : 'text-muted-foreground'
      }`}
    >
      {mins > 0 ? `${mins}m ` : ''}{String(secs).padStart(2, '0')}s
    </span>
  )
}

export function AvatarCircle({
  firstName,
  lastName,
  avatarUrl,
  size = 'md',
}: {
  firstName: string
  lastName: string
  avatarUrl?: string
  size?: 'sm' | 'md'
}) {
  const { resolvedTheme } = useTheme()
  const placeholder = resolvedTheme === 'dark'
    ? '/placeholder-dark/Place%20Holder%20Dark%204_4.png'
    : '/placeholder-light/Place%20Holder%20Light%204_4.png'

  const cls = size === 'sm' ? 'h-7 w-7' : 'h-9 w-9'

  return (
    <div className={`${cls} rounded-full border bg-muted flex items-center justify-center shrink-0 overflow-hidden`}>
      {avatarUrl ? (
        <ImageWithSkeleton
          src={avatarUrl}
          alt={`${firstName} ${lastName}`}
          className="h-full w-full object-cover"
        />
      ) : (
        <img src={placeholder} alt="Placeholder" className="h-full w-full object-cover opacity-60 grayscale" />
      )}
    </div>
  )
}
